<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">题问列表</li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="main-header"></div>
      <div class="main-table scroll-top">
        <table>
          <thead>
            <tr>
              <th>问题</th>
              <th style="width: 160px">时间</th>
              <th style="width: 160px">状态</th>
              <th style="width: 160px" class="center">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in questionList" :key="index">
              <td>
                <div class="list-title-name">
                  <div style="max-width: 340px" class="ellipsis" v-latex="item.qContent.replace(/(\\n)|\r?\n|\r/g, '<br/>')"></div>
                  <div v-if="item.teacherType == 3" class="transferred">
                    <img src="../../assets/images/Transferred.png" alt="">
                  </div>
                </div>
              </td>
              <td>
                {{ item.qTime }}
              </td>
              <td>
                <span class="color2" v-if="item.resolved"><i style="font-size:26px;vertical-align:-0.16em;">•</i> 已回答 </span>
                <span class="color0" v-else><i style="font-size:26px;vertical-align:-0.16em;">•</i> 未回答 </span>
                <span
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 3px;
                    margin-left: 10px;
                  "
                >
                  <img src="../../assets/images/icon-comment.png" height="16" />
                </span>
                <span
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    color: #999;
                    margin-right: 10px;
                  "
                  >{{ item.commentCount }}</span
                >
                <span
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 3px;
                  "
                >
                  <img src="../../assets/images/icon-good.png" height="16" />
                </span>
                <span
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    color: #999;
                  "
                  >{{ item.goodNum }}</span
                >
              </td>
              <td class="center">
                <Badge dot :count="!item.read && item.resolved ? 1 : 0">
                  <Button
                    v-if="item.exerId > 0"
                    type="primary"
                    shape="circle"
                    style="width: 70px; height: 28px; line-height: 28px"
                    :to="{
                      name: 'QuestionDetail',
                      query: { exerid: item.exerId, qid: item.qId },
                    }"
                    >查 看</Button
                  >
                  <Button
                    v-else
                    type="primary"
                    shape="circle"
                    style="width: 70px; height: 28px; line-height: 28px"
                    :to="{
                      name: 'QuestionDetail',
                      query: { pptid: item.pptId, qid: item.qId },
                    }"
                    >查 看</Button
                  >
                </Badge>

                <div style="display: inline-block; margin-left: 10px">
                  <Poptip
                    confirm
                    title="您确定要删除么?"
                    placement="top-end"
                    @on-ok="deleteQuestion(item)"
                    style="text-align: left"
                  >
                    <Button
                      type="error"
                      shape="circle"
                      style="width: 70px; height: 28px"
                      ghost
                      >删 除</Button
                    >
                  </Poptip>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="no-data" v-show="questionList.length == 0">
        <img src="../../assets/images/v3/no-data.png" />
        <p>聪明的你，还没有提任何问题</p>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";

export default {
  mixins: [siteMixin],
  data() {
    return {
      questionList: [],
    };
  },
  mounted() {
    this.setMetaData("我的提问");
    this.getMyQuestion();
  },
  methods: {
    getMyQuestion() {
      user.getMyQuestion(this.loginUser.userId).then((res) => {
        //console.log("questionList", res);
        if (res.status == 1) {
          this.questionList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    deleteQuestion(item) {
      //console.log(item);
      user.deleteMyQuestion(item.qId).then((res) => {
        if (res.status === 1) {
          this.$Message.success("删除成功");
          this.getMyQuestion();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
</style>